import RegExpSpecialSymbols from "./RegExpSpecialSymbols";
import DiacriticsUtil from "./DiacriticsUtil";
import {escapeHtmlSymbols} from "../atUtils";
import StringTokenizer from "./StringTokenizer";
import EmptyHighlighter from "./EmptyHighlighter";

export default function TokensHighlighter( tokens, punctuators, hlStart, hlEnd )
{
    // need to sort, because longest prefixes must be highlighted
    this.tokens = tokens.slice().sort( function ( a, b ) {return b.length - a.length;} );
    this.hlStart = hlStart || "<span class=\"highlightToken\">";
    this.hlEnd = hlEnd || "</span>";
    this.pattern = "(^|[\\s"+ RegExpSpecialSymbols.escapeRegexpSpecialSymbols(punctuators) +"])((";
    this.pattern += DiacriticsUtil.makeMatchingRegexp(this.tokens[0]);
    for( var i = 1; i < this.tokens.length; i++ )
        this.pattern += ")|(" + DiacriticsUtil.makeMatchingRegexp(this.tokens[i]);
    this.pattern += "))";
}

TokensHighlighter.prototype.highlightTokens = function( text )
{
    if (!text)
        return null;

    var regexp = new RegExp(this.pattern, "gi");

    var lastIndex = 0;
    var result = "";
    var found = regexp.exec( text );

    while( found )
    {
        var token = found[2];
        result += escapeHtmlSymbols(text.substring( lastIndex, regexp.lastIndex - token.length ));
        result += this.hlStart + escapeHtmlSymbols(token) + this.hlEnd;
        lastIndex = regexp.lastIndex;
        found = regexp.exec( text );
    }
    result += escapeHtmlSymbols(text.substring(lastIndex));
    return result;
};

export function createTokensHighlighterForSearch(searchString) {
    if (!searchString)
        return new EmptyHighlighter();

    const stringTokenizer = new StringTokenizer(StringTokenizer.PUNCTUATORS_FOR_SEARCH)
    const tokens = stringTokenizer.getTokens(searchString)
    if (tokens.length === 0)
        return new EmptyHighlighter();
    return new TokensHighlighter(tokens, stringTokenizer.getPunctuators())
}



// WEBPACK FOOTER //
// ./web/js/util/TokensHighlighter.js